import { ReactNode } from 'react';
import styles from './SectionHead.module.css';

interface SectionHeadProps {
  eyebrow?: ReactNode;
  title: ReactNode;
  italic?: ReactNode;
  sub?: ReactNode;
}

/** Reusable editorial heading: tiny tracked eyebrow + Fraunces display title. */
export function SectionHead({ eyebrow, title, italic, sub }: SectionHeadProps) {
  return (
    <header className={styles.head}>
      {eyebrow && <div className={styles.eyebrow}>{eyebrow}</div>}
      <h1 className={styles.title}>
        {title}
        {italic ? <em> {italic}</em> : null}
      </h1>
      {sub && <p className={styles.sub}>{sub}</p>}
    </header>
  );
}
